module.exports = __webpack_public_path__ + "static/cake_mousse_heart_02-cbb0c5a15f4bdc3844866b764bce5c22.jpg";